import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { setActiveCrew } from '../../redux/calendar';
import { dispatchEvent, previewEvent } from '../../redux/dispatcher';
import { unassignedEventsSelector, visibleEventsSelector } from '../../redux/events';
import makeEventsByCrew from '../../selectors/eventsByCrew';
import Dispatcher from './Dispatcher';

const eventsByCrew = makeEventsByCrew(false);

const mapEvents = createSelector(
  visibleEventsSelector,
  (events) => events.map((e) => ({
    ...e,
    geoPoint: (e.job && e.job.geoPoint) || (e.purchaseOrder && e.purchaseOrder.items.filter(e => e.job && e.job.geoPoint).map(e => e.job.geoPoint)[0])
  })).filter((e) => e.geoPoint && e.geoPoint.latitude && e.geoPoint.longitude)
);

const mapStateToProps = (state) => ({
  ...state.dispatcher,
  activeCrew: state.calendar.activeCrew,
  date: state.calendar.date,
  defaultCenter: {
    lat: state.organization.latitude,
    lng: state.organization.longitude
  },
  detailEnabled: state.settings.detailEnabled,
  financialEnabled: state.settings.financialEnabled,
  materialEnabled: state.settings.materialEnabled,
  unassignedEvents: unassignedEventsSelector(state),
  eventsByCrew: eventsByCrew(state),
  mapEvents: mapEvents(state)
});

const mapDispatchToProps = ({
  onDispatch: dispatchEvent,
  onPreviewEvent: previewEvent,
  onCrewSelect: setActiveCrew
});

export default connect(mapStateToProps, mapDispatchToProps)(Dispatcher);
